export const SET_DEALER_INFO = 'SET_DEALER_INFO';
export const SET_MAP_LINK = 'SET_MAP_LINK';
export const SET_CONTACT_INFO = 'SET_CONTACT_INFO';



// WEBPACK FOOTER //
// ./src/actions/types.js